module.exports = __webpack_public_path__ + "042468300dab6f308592e15e02549c79.woff";